/**
 * Stable CSS class names for E2E — Orders page.
 */
export const O = {
    page: 'orders-page',
    breadcrumbSection: 'orders-page__breadcrumb-section',
    loadingSection: 'orders-page__loading-section',

    detailDrawerPaper: 'orders-page__detail-drawer-paper',
    filterDrawerPaper: 'orders-page__filter-drawer-paper',

    resultsLayout: 'orders-page__results-layout',
    actionsRow: 'orders-page__actions-row',
    lastSearchedButtonWrap: 'orders-page__last-searched-button-wrap',
    lastSearchedIconButton: 'orders-page-input--button-last-searched',
    openFilterButtonWrap: 'orders-page__open-filter-button-wrap',
    openFilterIconButton: 'orders-page-input--button-open-filter',
    excelDownloadWrap: 'orders-page__excel-download-wrap',
    dataGridWrap: 'orders-page__data-grid-wrap',

    cellCustomerWrap: 'orders-page__cell-customer-wrap',
    cellCustomerButton: 'orders-page-input--button-cell-customer',
    cellEmailWrap: 'orders-page__cell-email-wrap',
    cellEmailButton: 'orders-page-input--button-cell-email',
    cellOrderNumberWrap: 'orders-page__cell-order-number-wrap',
    cellOrderNumberLink: 'orders-page-input--link-cell-order-number',
    cellOrderStatusWrap: 'orders-page__cell-order-status-wrap',
    cellShippingListNoWrap: 'orders-page__cell-shipping-list-no-wrap',
    cellPaymentMethodWrap: 'orders-page__cell-payment-method-wrap',
    cellStoreCodeWrap: 'orders-page__cell-store-code-wrap',
    cellOrderDateWrap: 'orders-page__cell-order-date-wrap',
    cellActionsButton: 'orders-page-input--button-cell-actions',
    cellActionsMenu: 'orders-page-input--menu-cell-actions',
    cellActionsMenuItemReturn: 'orders-page-input--menu-item-cell-actions-return',
    cellActionsMenuItemDetail: 'orders-page-input--menu-item-cell-actions-go-to-detail',
    cellActionsMenuItemQuickView: 'orders-page-input--menu-item-cell-actions-quick-view',

    emptyState: 'orders-page__empty-state',
    emptyStateOpenFilterWrap: 'orders-page__empty-state-open-filter-wrap',
    emptyStateOpenFilterIconButton: 'orders-page-input--button-empty-state-open-filter',

    recentSearchesSection: 'orders-page__recent-searches-section',
    recentSearchesHeader: 'orders-page__recent-searches-header',
    recentSearchesTitleGroup: 'orders-page__recent-searches-title-group',
    recentSearchesTitle: 'orders-page__recent-searches-title',
    recentSearchesCountChip: 'orders-page__recent-searches-count-chip',
    recentSearchesActions: 'orders-page__recent-searches-actions',
    recentSearchesSearchButton: 'orders-page-input--button-recent-searches-search',
    recentSearchesClearButton: 'orders-page-input--button-recent-searches-clear',

    recentSearchesList: 'orders-page__recent-searches-list',
    recentSearchCard: 'orders-page__recent-search-card',
    recentSearchCardContent: 'orders-page__recent-search-card-content',
    recentSearchCardLayout: 'orders-page__recent-search-card-layout',
    recentSearchCardBody: 'orders-page__recent-search-card-body',
    recentSearchCardMeta: 'orders-page__recent-search-card-meta',
    recentSearchCardDate: 'orders-page__recent-search-card-date',
    recentSearchCardIndexChip: 'orders-page__recent-search-card-index-chip',
    recentSearchCardChips: 'orders-page__recent-search-card-chips',
    recentSearchCardChip: 'orders-page__recent-search-card-chip',
    recentSearchCardEmpty: 'orders-page__recent-search-card-empty',
    recentSearchCardActions: 'orders-page__recent-search-card-actions',
    recentSearchDeleteButton: 'orders-page-input--button-recent-search-delete',
} as const;

export const oCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
